import { render, staticRenderFns } from "./WDataTable.vue?vue&type=template&id=0c79b06c&"
import script from "./WDataTable.vue?vue&type=script&lang=js&"
export * from "./WDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports